export default "__VITE_ASSET__XUSn4JBb__"